
/* INT 2026-06: desktop swatch hold. On a colour change VIA re-inits Flickity at
   ~324ms and swaps the selected slide's <img> src to the new variant hero, which
   is undecoded for a beat (imgOk 1->0); that undecoded gap is the flash on the
   big image container. Confirmed: no cell teardown (6->6, zero blank frames) and
   no track sweep, both already fixed. The existing intHeroHold misses this case
   because it reacts to slider childList / class mutations, not the in-place src
   swap. This holds a clone of the outgoing hero on a still overlay the instant
   the swatch is clicked, parented to the Flickity viewport (a sibling of the
   slider, so VIA's cell re-init leaves it alone), and removes it the moment the
   newly selected slide's image has decoded on its new src. The clone shares the
   cached, already-decoded outgoing src so it paints immediately. Desktop only;
   mobile switches instantly and does not show this gap. */
(function () {
  'use strict';
  if (window.__intSwatchHold) return;
  window.__intSwatchHold = true;

  function viewportOf(ss) {
    return ss.querySelector('.flickity-viewport') || ss.querySelector('.product__grid--slides') || ss;
  }
  function selectedImg(ss) {
    var sel = ss.querySelector('[data-media-slide].is-selected') || ss.querySelector('[data-media-slide]');
    return sel ? sel.querySelector('img') : null;
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('.int-gswatch');
    if (!sw || sw.classList.contains('int-gswatch--active')) return;
    if (!(window.matchMedia && window.matchMedia('(min-width: 769px)').matches)) return;

    var ss = document.querySelector('[data-product-slideshow]');
    if (!ss) return;
    var vp = viewportOf(ss);
    var outImg = selectedImg(ss);
    if (!outImg || !outImg.currentSrc) return;
    var outSrc = outImg.currentSrc;

    /* INT 2026-06: gate release on the TARGET hero, not "first decoded new src".
       The probe showed selected goes White(wrong) -> none(gap) -> Rope(right),
       with the right hero only landing ~552ms in, but the old release fired at
       ~172ms during the none-gap on a fallback slide, leaving a ~380ms uncovered
       window where the rebuilding image bleeds partway in. Resolve the target
       hero media-id from the swatch's variant via the hero map so the still
       frame only drops once the correct, decoded hero is actually selected. */
    var _vid = sw.dataset.variantId;
    var expectedHero = (window.__intVariantHeroMap && _vid) ? String(window.__intVariantHeroMap[String(_vid)] || '') : '';

    var existing = document.getElementById('int-swatch-hold');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

    var slideBg = '#fff';
    try {
      var c = getComputedStyle(outImg.closest('[data-media-slide]') || vp).backgroundColor;
      if (c && c !== 'rgba(0, 0, 0, 0)' && c !== 'transparent') slideBg = c;
    } catch (e) {}

    var cs = getComputedStyle(outImg);
    var ov = document.createElement('div');
    ov.id = 'int-swatch-hold';
    ov.setAttribute('aria-hidden', 'true');
    ov.style.cssText = 'position:absolute;inset:0;z-index:5;pointer-events:none;overflow:hidden;background:' + slideBg + ';';

    var clone = document.createElement('img');
    clone.src = outSrc;
    clone.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:' +
      (cs.objectFit || 'contain') + ';object-position:' + (cs.objectPosition || 'center') + ';';
    ov.appendChild(clone);

    /* INT 2026-06: parent the overlay to the slideshow, not the viewport. The
       confirm probe showed VIA rebuilds the viewport subtree and tears a
       viewport-child overlay out as collateral (removed at 1185ms inside a VIA
       mutation while the gate still read match=1 dec=0), so the gated release
       never got the final say, and which colour flashed depended only on when
       VIA's rebuild fired relative to decode. The slideshow element is stable
       (ssH held at 318 throughout, all mutations were inside the viewport), so an
       overlay parented here is a sibling of the viewport and survives the
       rebuild, while still covering the same box via inset:0. Now only the gated
       release or the timeout can remove it. */
    if (getComputedStyle(ss).position === 'static') ss.style.position = 'relative';
    ss.appendChild(ov);

    /* INT 2026-06: desktop viewport height lock. The probe showed the viewport
       spikes to 600px around 50ms when VIA re-inits and a cell is briefly
       measured at its natural height, reflowing everything below the gallery as a
       jump the overlay cannot hide. Stamp the settled height and clamp only large
       upward spikes, so the theme's own _intSetVPHeight refinement (normally
       within 60px) is left alone. Mirrors the sub-768px block already in the
       click handler. */
    var lockedH = Math.round(vp.getBoundingClientRect().height);
    var hMo = null;
    if (lockedH > 80) {
      vp.style.height = lockedH + 'px';
      ss.style.height = lockedH + 'px';
      ss.style.minHeight = lockedH + 'px';
      hMo = new MutationObserver(function () {
        var cur = parseFloat(vp.style.height) || 0;
        if (cur > lockedH + 60) vp.style.height = lockedH + 'px';
      });
      hMo.observe(vp, { attributes: true, attributeFilter: ['style'] });
    }

    var start = performance.now();
    var matchedSince = 0;
    var repainted = false;
    function release() {
      if (hMo) { hMo.disconnect(); hMo = null; }
      if (ov && ov.parentNode) ov.parentNode.removeChild(ov);
      /* INT 2026-07c: the height lock above stamped vp/ss heights from the
         OUTGOING colour and clamped taller writes during the transition.
         If the incoming hero is taller, it renders bottom-cropped. The
         release gate guarantees the new hero is selected + decoded here,
         so recalc the viewport height from its natural dimensions. */
      if (typeof window.__intSetVPHeight === 'function') {
        requestAnimationFrame(function() { window.__intSetVPHeight(); });
      }
    }
    function tick() {
      /* INT 2026-06: repaint the overlay to the NEW hero the moment its cell is
         decoded, instead of waiting for VIA to mark it selected. The gap probe
         showed the hero cell is present and decoded at ~150ms but VIA does not
         select it until ~550ms, so the overlay was holding the OLD frame for a
         flat ~400ms over an image already paintable. Swapping the clone src here
         moves the visible colour change to decode time, while the removal gate
         below still waits for selection so the flash protection is unchanged.
         Fires only when the hero map resolved and that exact cell is decoded on a
         new src; on a cold load where it is not yet decoded this simply does not
         fire and the old frame holds until selection, never worse than today. */
      if (!repainted && expectedHero) {
        var heroCell = ss.querySelector('[data-media-slide][data-media-id="' + expectedHero + '"]');
        var heroImg = heroCell && heroCell.querySelector('img');
        if (heroImg && heroImg.complete && heroImg.naturalWidth > 0 && heroImg.currentSrc && heroImg.currentSrc !== outSrc) {
          clone.src = heroImg.currentSrc;
          repainted = true;
        }
      }
      var sel = ss.querySelector('[data-media-slide].is-selected');
      var img = sel && sel.querySelector('img');
      var decoded = img && img.complete && img.naturalWidth > 0;
      /* With a hero map, require the SELECTED slide to be that exact hero and
         decoded. Without one (variant lacking featured_media), fall back to the
         selected slide decoded on a src that differs from the outgoing. Either
         way require an 80ms settle so a transient wrong-cell selection during
         VIA's rebuild cannot drop the frame early. */
      var ready = expectedHero
        ? (sel && decoded && sel.dataset.mediaId === expectedHero)
        : (sel && decoded && img.currentSrc && img.currentSrc !== outSrc);
      if (ready) {
        if (!matchedSince) matchedSince = performance.now();
        if (performance.now() - matchedSince >= 80) { requestAnimationFrame(release); return; }
      } else {
        matchedSince = 0;
      }
      if (performance.now() - start > 1500) { release(); return; }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }, true);
})();
